import { createFileRoute } from "@tanstack/react-router"
import { Suspense } from "react"
import { TripPage } from "@/components/pages/TripPage/lazy"
import { NotFound } from "@/components/NotFound"
import { useCanonicalId } from "@/lib/hooks/use-canonical-id"

function GuideEditPageRoute() {
  const { guideId: param } = Route.useParams()
  const guideId = useCanonicalId(`guide`, param)
  if (guideId === undefined) return null
  if (guideId === null) return <NotFound />
  // TripPage is lazy (see lazy.ts) — Suspense covers the chunk fetch.
  return (
    <Suspense fallback={null}>
      <TripPage guideId={guideId} readOnly={false} />
    </Suspense>
  )
}

// Guide data loads via tRPC/React Query (useGuideData) on mount.
export const Route = createFileRoute(
  `/_authenticated/guide/$slug/$guideId/edit`
)({
  component: GuideEditPageRoute,
  ssr: false,
})
